import React from 'react'

export default function ReceiptsListFooterStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        #receipts-list-footer-container {
          display: flex;
          margin-right: 17px;
        }
      `}
      </style>
    </React.Fragment>
  )
}
